document.addEventListener("DOMContentLoaded", function () {
  {
    // section-products-ranking
    const buttons = document.querySelectorAll(
      ".section-products-ranking .button"
    );
    const items = document.querySelectorAll(".section-products-ranking .items");

    const loadImagesInTab = (tabElement) => {
      if (!tabElement) return;
      const imgs = tabElement.querySelectorAll(
        ".product-card-default-thum-image"
      );
      imgs.forEach((img) => {
        if (!img.complete && img.src) {
          new Image().src = img.src;
          if (img.decode) img.decode().catch(() => {});
        }
      });
    };

    for (let i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", function () {
        for (let j = 0; j < buttons.length; j++) {
          buttons[j].classList.remove("is-current");
          items[j].classList.remove("is-current");
        }

        const index = Array.prototype.indexOf.call(buttons, this);
        this.classList.add("is-current");
        const activeTab = items[index];
        if (activeTab) {
          activeTab.classList.add("is-current");
          requestAnimationFrame(() => {
            if (window.themeV2?.resetProductCardImages) {
              window.themeV2.resetProductCardImages();
            }
            loadImagesInTab(activeTab);
            if (window.themeV2?.setSwipeProductCardImage) {
              window.themeV2.setSwipeProductCardImage();
            }
          });
        }
      });
    }
  }
});
